var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * ArrowUpAlt component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconArrowUpAlt extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.5307 2.32465C12.2378 2.03176 11.763 2.03176 11.4701 2.32465L6.54584 7.24888C6.25295 7.54177 6.25295 8.01665 6.54584 8.30954C6.83873 8.60243 7.31361 8.60243 7.6065 8.30954L11.2502 4.6658V21.2799C11.2502 21.6776 11.586 22 12.0002 22C12.4145 22 12.7502 21.6776 12.7502 21.2799V4.66548L16.3943 8.30954C16.6872 8.60243 17.1621 8.60243 17.455 8.30954C17.7479 8.01665 17.7479 7.54177 17.455 7.24888L12.5307 2.32465Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconArrowUpAlt.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowUpAlt.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowUpAlt.prototype, "size", void 0);
if (customElements.get('cat-icon-arrow-up-alt') === undefined) {
    customElements.define('cat-icon-arrow-up-alt', BlocksIconArrowUpAlt);
}
